import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

// Ersetzt bewusst das generierte `attachSupabaseAuth`: dort wird der Supabase-
// Client statisch importiert, wodurch das komplette supabase-js (auth/realtime/
// storage) im Einstiegs-Bundle jeder öffentlichen Seite landet. Hier wird der
// Client erst dynamisch geladen, wenn tatsächlich ein serverFn-Call ansteht —
// und nur, wenn im Browser überhaupt ein Auth-Token hinterlegt ist.
const hasStoredSupabaseSession = (): boolean => {
  if (typeof window === "undefined") return false;
  // In der Lovable-Vorschau liegt die Sitzung NICHT im lokalen Speicher, sondern
  // wird vom Editor über postMessage bereitgestellt. Dort muss der Client immer
  // gefragt werden, sonst ginge der Anmeldenachweis verloren (401).
  try {
    if (window.parent && window.parent !== window) return true;
  } catch {
    return true;
  }
  try {
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith("sb-") && key.endsWith("-auth-token")) return true;
    }
  } catch {
    return false;
  }
  return false;
};


const attachSupabaseAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  if (!hasStoredSupabaseSession()) return next({ headers: {} });
  const { supabase } = await import("./integrations/supabase/client");
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
});

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  const url = new URL(request.url);
  if (url.pathname.startsWith("/lovable/") || url.pathname === "/email/unsubscribe") {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));

